import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Login from "../Pages/Login";
import HomePage from "../Pages/HomePage";
import VideoPlayer from "../Pages/VideoPlayer";
import SettingsPage from "../Pages/SettingsPage";
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import AdminLoginPage from "../Pages/Admin/AdminLoginPage";
import NotFound from "../Pages/404Page";
import CustomErrorPage from "../Pages/ErrorBoundary";
import ApiTester from "../Pages/DummyPage";
import LandingPage from "../Pages/LandingPage";
import VideosPage from "../Pages/VideosPage";
import AboutUsPage from "../Pages/AboutUsPage";
import ContactUsPage from "../Pages/ContactUsPage";
import RegisterPage from "../Pages/Register";


const router = createBrowserRouter([

  {
    path: "/login",
    element: <Login />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/videos",
    element: <HomePage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/video/:id",
    element: <VideoPlayer />,
    errorElement: <CustomErrorPage />,
  },
   
  {
    path: "/videos/temp",
    element: <VideosPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/about",
    element: <AboutUsPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/contact",
    element: <ContactUsPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
    errorElement: <CustomErrorPage />,
  },
  {
    path: "/dummy",
    element: <ApiTester />,
    errorElement: <CustomErrorPage />,
  },

  {
    path: "*",
    element: <NotFound />,
    errorElement: <CustomErrorPage />,
  },

]);

const AppRoutes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;
